import { UNKNOWN_ERROR } from "@/constants/common"
import { Toast, ToastVariant } from "@/constants/toast"
import { toast } from "@/redux/reducers/toast"
import { TCSAPIResponse } from "@/types/types"

export const showNotification = (
  response: { data: TCSAPIResponse | undefined, err: string | undefined },
  onSuccessMessage: string,
  formattedMessageLibrary: Record<string, string>
): void => {
  const isSuccess = (response.data?.success ?? response.data)

  const title = isSuccess ? Toast.SUCCESS : Toast.ERROR
  const variant = isSuccess ? ToastVariant.SUCCESS : ToastVariant.ERROR
  const errorMessage = formattedMessageLibrary[response.err ?? ''] ?? response.err ?? UNKNOWN_ERROR
  const description = isSuccess ? onSuccessMessage : errorMessage

  toast({ title, variant, description })
}
